(function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  function getScrollable() {
    return drawer.querySelector('.drawer__scrollable');
  }
  function getArrow() {
    return drawer.querySelector('.cart-scroll-arrow');
  }

  function updateArrow() {
    const scrollable = getScrollable();
    const arrow = getArrow();
    if (!scrollable || !arrow) return;

    const hasMoreBelow =
      scrollable.scrollHeight - scrollable.scrollTop - scrollable.clientHeight > 20;
    arrow.classList.toggle('is-visible', hasMoreBelow);
  }

  // CLICK — delegated to the drawer, so it works even after re-render
  drawer.addEventListener('click', function (e) {
    const arrow = e.target.closest('.cart-scroll-arrow');
    if (!arrow) return;
    const scrollable = getScrollable();
    if (scrollable) {
      scrollable.scrollBy({ top: 200, behavior: 'smooth' });
    }
  });

  // SCROLL — capture phase on the drawer catches scroll events from
  // any current or future .drawer__scrollable inside it
  drawer.addEventListener('scroll', updateArrow, { capture: true, passive: true });

  // Re-check whenever drawer content is replaced (item added/removed)
  // or open/active attributes change
  new MutationObserver(function () {
    // small delay so the new HTML finishes rendering first
    setTimeout(updateArrow, 100);
    setTimeout(updateArrow, 400); // second pass after images/animations settle
  }).observe(drawer, {
    attributes: true,
    attributeFilter: ['open', 'active', 'class'],
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', updateArrow);
  updateArrow();
})();





(function () {
  const BATCH_MS = 180;
  let patched = false;

  function sectionIdOf(el) {
    return el.sectionId || el.getAttribute('data-section-id') || el.dataset?.sectionId || null;
  }

  function findRow(itemsEl, line) {
    const direct = document.getElementById(`CartDrawer-Item-${line}`);
    if (direct) return direct;
    return [...itemsEl.querySelectorAll('li[id]')].find((li) => li.id.endsWith(line)) || null;
  }

  function markRow(itemsEl, line, on) {
    const row = findRow(itemsEl, line);
    if (row) {
      row.classList.toggle('pointer-events-none', on);
      row.classList.toggle('cart-row--removing', on);
    }
    const sid = sectionIdOf(itemsEl);
    const loader = sid && document.getElementById(`Loader-${sid}-${line}`);
    if (loader) loader.hidden = !on;
  }

  function applyPatch() {
    if (patched) return true;
    const CartItems = customElements.get('cart-items');
    if (!CartItems) return false;

    const proto = CartItems.prototype;
    if (proto._multiRemovePatched) return (patched = true);

    const original = proto.updateQuantity;

    proto.updateQuantity = function (line, quantity, name, target) {
      if (parseInt(quantity, 10) !== 0) {
        return original.call(this, line, quantity, name, target);
      }

      this._pending = this._pending || new Set();
      this._chain = this._chain || Promise.resolve();

      if (this._pending.has(line)) return;
      this._pending.add(line);

      markRow(this, line, true);

      clearTimeout(this._timer);
      this._timer = setTimeout(() => this._flushRemovals(), BATCH_MS);
    };

    proto._flushRemovals = function () {
      const keys = [...this._pending];
      this._pending.clear();
      if (!keys.length) return;

      const updates = {};
      keys.forEach((k) => (updates[k] = 0));

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
      );
      const sid = sectionIdOf(this);
      if (sid && !sections.includes(sid)) sections.push(sid);

      const url = window.theme.routes.cart_update_url + '.js';
      const config = window.theme.utils.fetchConfig();

      this._chain = this._chain.then(() =>
        fetch(url, { ...config, body: JSON.stringify({ updates, sections }) })
          .then((r) => {
            if (!r.ok) throw new Error('cart/update.js ' + r.status);
            return r.json();
          })
          .then((cart) => {
            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cart,
              target: this,
              line: keys[keys.length - 1],
              name: undefined
            });
          })
          .catch((err) => {
            //console.error('[multi-remove] failed', err);
            keys.forEach((k) => markRow(this, k, false));
          })
      );
    };

    proto._multiRemovePatched = true;
    patched = true;
    //console.log('[multi-remove] patch applied');
    return true;
  }

  // Try now, then wait for the definition, then poll as a last resort.
  if (!applyPatch()) {
    if (customElements.whenDefined) {
      customElements.whenDefined('cart-items').then(applyPatch);
    }
    let tries = 0;
    const poll = setInterval(() => {
      if (applyPatch() || ++tries > 100) clearInterval(poll);
    }, 100);
    document.addEventListener('DOMContentLoaded', applyPatch);
    window.addEventListener('load', applyPatch);
  }
})();




(function () {
    var btn = document.getElementById('back-to-top');
    if (!btn) return;

    var showAfter = 300; // pixels scrolled before the button appears

    function toggleButton() {
      if (window.scrollY > showAfter) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', toggleButton, { passive: true });
    toggleButton();

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();





document.querySelectorAll('.zs-video-wrapper').forEach((wrapper) => {
  const video = wrapper.querySelector('.zs-video');
  const poster = wrapper.querySelector('.zs-video-poster');
  const button = wrapper.querySelector('.zs-play-btn');

  if (!video || !button) return;

  button.addEventListener('click', () => {

    // PLAY CURRENT VIDEO
    if (video.paused) {

      // Stop all other videos first
      document.querySelectorAll('.zs-video-wrapper').forEach((otherWrapper) => {
        if (otherWrapper === wrapper) return;

        const otherVideo = otherWrapper.querySelector('.zs-video');
        const otherPoster = otherWrapper.querySelector('.zs-video-poster');
        const otherButton = otherWrapper.querySelector('.zs-play-btn');

        if (otherVideo && !otherVideo.paused) {
          otherVideo.pause();

          otherPoster?.classList.remove('is-hidden');
          otherWrapper.classList.remove('is-playing');

          otherButton?.setAttribute('aria-label', 'Play video');
        }
      });

      // Play clicked video
      video.play();

      poster?.classList.add('is-hidden');
      wrapper.classList.add('is-playing');

      button.setAttribute('aria-label', 'Pause video');
    }

    // PAUSE CURRENT VIDEO
    else {
      video.pause();

      poster?.classList.remove('is-hidden');
      wrapper.classList.remove('is-playing');

      button.setAttribute('aria-label', 'Play video');
    }

  });
});










// review-pdp-info-widget
document.getElementById('okendo-promo').addEventListener('click', function() {
  var reviewSection = document.querySelector('.okeReviews') || document.querySelector('[data-oke-widget]');
  if (reviewSection) {
    var yOffset = reviewSection.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: yOffset, behavior: 'smooth' });
  }
});




(function () {
    var block = document.currentScript.previousElementSibling;
    if (!block || block.dataset.swatchLimited) return;
    block.dataset.swatchLimited = 'true';

    var limit = parseInt(block.dataset.swatchLimit, 10) || 4;
    var skip = { INPUT: 1, SCRIPT: 1, STYLE: 1 };

    // The swatch list = the element inside the block with the most visible children
    var list = null, items = [];
    block.querySelectorAll('*').forEach(function (el) {
      var kids = Array.prototype.filter.call(el.children, function (c) { return !skip[c.tagName]; });
      if (kids.length > items.length) { list = el; items = kids; }
    });
    if (!list || items.length <= limit) return;

    // Find the selected swatch and move it to the front
    var productPath = (block.dataset.productUrl || '').split('?')[0];
    var selectedRe = /(^|[\s_-])(active|selected|current|checked|is-active|is-selected)($|[\s_-])/i;
    function isSelected(el) {
      var prev = el.previousElementSibling;
      if (prev && prev.tagName === 'INPUT' && prev.checked) return true;
      if (el.querySelector('input:checked')) return true;
      if (el.matches('[aria-current], [aria-checked="true"], [aria-selected="true"]')) return true;
      if (el.querySelector('[aria-current], [aria-checked="true"], [aria-selected="true"]')) return true;
      if (selectedRe.test(el.className || '')) return true;
      var inner = el.querySelector('[class]');
      if (inner && selectedRe.test(inner.className || '')) return true;
      var link = el.tagName === 'A' ? el : el.querySelector('a[href]');
      if (link && productPath && link.getAttribute('href').split('?')[0] === productPath) return true;
      return false;
    }
    var selected = items.filter(isSelected)[0];
    if (selected && selected !== items[0]) {
      var first = items[0];
      var firstInput = first.previousElementSibling;
      var anchor = (firstInput && firstInput.tagName === 'INPUT') ? firstInput : first;
      var selInput = selected.previousElementSibling;
      if (selInput && selInput.tagName === 'INPUT') list.insertBefore(selInput, anchor);
      list.insertBefore(selected, anchor);
      items.splice(items.indexOf(selected), 1);
      items.unshift(selected);
    }

    // Hide everything after the first 4
    items.slice(limit).forEach(function (el) { el.style.display = 'none'; });

    // Add the "+N" link
    var more = document.createElement('a');
    more.className = 'swatch-more';
    more.href = block.dataset.productUrl;
    more.textContent = '+' + (items.length - limit);
    more.setAttribute('aria-label', (items.length - limit) + ' more options');
    list.appendChild(more);
  })();




// document.addEventListener("click", function (e) {
//   let accordion = null;
//   let content = null;

//   // --- CASE 1: Normal accordion click ---
//   if (e.target.classList.contains("product-size-guide-accordion")) {
//     accordion = e.target;
//     content = accordion.nextElementSibling;
//   }

//   // --- CASE 2: last-accordion-open click ---
//   if (e.target.classList.contains("last-accordion-open")) {
//     accordion = document.querySelector(".product-size-guide-button-last");
//     content = document.querySelector(".product-size-guide-content-last");
//   }

//   if (!accordion) return;

//   // Close all other accordions first
//   document.querySelectorAll(".product-size-guide-accordion.is-open, .product-size-guide-button-last.is-open").forEach(openAccordion => {
//     if (openAccordion !== accordion) {
//       openAccordion.classList.remove("is-open");
//       const otherContent = openAccordion.nextElementSibling 
//                         || document.querySelector(".product-size-guide-content-last");
//       if (otherContent) otherContent.style.maxHeight = null;
//     }
//   });

//   // Toggle clicked accordion
//   const isOpening = !accordion.classList.contains("is-open");
//   accordion.classList.toggle("is-open", isOpening);
//   if (content) {
//     content.style.maxHeight = isOpening ? content.scrollHeight + "px" : null;
//   }
// });





document.addEventListener("DOMContentLoaded", function() {
  const targetSelector = '.oke-w-header-content-block.oke-w-header-content-block--twoThirds.oke-w-header-content-block--left';
  
  const disclaimerText = '<div class="custom-okendo-disclaimer" style="font-size: 12px; color: #666; margin-top: 8px; text-align: center; width: 100%;">Customers may have received an incentive to leave reviews. Incentive was provided whether a positive or a negative review was left.</div>';

  function injectDisclaimer() {
    const targetElement = document.querySelector(targetSelector);
    
    if (targetElement && !targetElement.querySelector('.custom-okendo-disclaimer')) {
      targetElement.insertAdjacentHTML('beforeend', disclaimerText);
    }
  }

  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        shouldCheck = true;
      }
    });
    if (shouldCheck) {
      injectDisclaimer();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  injectDisclaimer();
});






